export default __webpack_public_path__ + "static/hover14-765ac24912b1b3c9c057614ddbc2ee99.png";